import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createContractor,
  deleteContractor,
  getContractor,
  getContractors,
  getContractorsMasterData,
  showHideContractor,
  updateContractor
} from '../../../api/contractors';

export const getContractorsAsync = createAsyncThunk(
  'contractors/getContractors',
  getContractors
);

export const getContractorsMasterDataAsync = createAsyncThunk(
  'contractors/getContractorsMasterData',
  getContractorsMasterData
);

export const getContractorAsync = createAsyncThunk(
  'contractors/getContractor',
  getContractor
);

export const createContractorAsync = createAsyncThunk(
  'contractors/createContractor',
  createContractor
);

export const updateContractorAsync = createAsyncThunk(
  'contractors/updateContractor',
  updateContractor
);

export const showHideContractorAsync = createAsyncThunk(
  'contractors/showHideContractor',
  showHideContractor
);

export const deleteContractorAsync = createAsyncThunk(
  'contractors/deleteContractor',
  deleteContractor
);

export interface Contractor {
  id: number;
  name: string;
  isActive: boolean;
}

interface ContractorState {
  data: Contractor[];
  masterData: Contractor[];
  count: number;
  selectedContractor: Contractor | null;
}

const initialState: ContractorState = {
  data: [],
  masterData: [],
  count: 0,
  selectedContractor: null
};

export default createSlice({
  name: 'contractors',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getContractorsAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
    builder.addCase(
      getContractorsMasterDataAsync.fulfilled,
      (state, action) => {
        state.masterData = action.payload.data;
        state.count = action.payload.count;
      }
    );
    builder.addCase(getContractorAsync.fulfilled, (state, action) => {
      state.selectedContractor = action.payload;
    });
  }
});
